document.addEventListener('DOMContentLoaded', function() {

    let burger = document.getElementById('burger');
    let nav = document.getElementById('main-nav');


    function closeMenu() {
        burger.classList.remove('is-open');
        nav.classList.remove('is-open');
        document.body.classList.remove('mobile-nav-is-open');
        const noScrollStyle = document.getElementById('no-scroll-style');
        if (noScrollStyle) {
            noScrollStyle.remove();
        }
    }

    if (burger && nav) {
        burger.addEventListener('click', function(e){
            e.preventDefault(); // Prevent default anchor behavior if burger is an <a>
            this.classList.toggle('is-open');
            nav.classList.toggle('is-open');

            // Optional: Toggle body class to prevent scrolling when menu is open
            document.body.classList.toggle('mobile-nav-is-open');

            const noScrollStyle = document.getElementById('no-scroll-style');
            if (document.body.classList.contains('mobile-nav-is-open')) {
                if (!noScrollStyle) {
                    const style = document.createElement('style');
                    style.id = 'no-scroll-style';
                    style.innerHTML = `
                        html, body {
                            overflow: hidden !important;
                            height: 100% !important;
                        }
                    `;
                    document.head.appendChild(style);
                }
            } else {
                if (noScrollStyle) {
                    noScrollStyle.remove();
                }
            }

            if (nav.classList.contains('is-open')) {
                // Force a reflow to ensure menu positions correctly after sticky header might have changed
                void nav.offsetHeight;
            }
        });

        // Close menu when clicking on the nav background
        nav.addEventListener('click', function(e) {
            if (e.target === this) {
                closeMenu();
            }
        });

    } else {
        console.warn('Mobile menu elements (burger or main-nav) not found.');
    }

    // Accordion Sub-menu functionality
    const submenuToggles = document.querySelectorAll('.main-nav .has-submenu > .main-nav-link');

    submenuToggles.forEach(toggle => {
        toggle.addEventListener('click', function(event) {
            // Check if the link is meant to navigate (i.e., href is not 'javascript:void(0);')
            // This check is a bit redundant now since we force javascript:void(0) for parents in liquid,
            // but good for robustness if HTML changes.
            if (this.getAttribute('href') === 'javascript:void(0);' || this.closest('.has-submenu').querySelector('.submenu-content')) {
                event.preventDefault(); // Prevent navigation if it's a toggle
                const parentLi = this.closest('.has-submenu');
                if (parentLi) {
                    parentLi.classList.toggle('submenu-is-open');
                    const indicator = this.querySelector('.submenu-toggle-indicator');
                    if (indicator) {
                        // indicator.textContent = parentLi.classList.contains('submenu-is-open') ? '-' : '+';
                        // The rotation is handled by CSS now, so textContent change isn't strictly needed for '+' to 'x'
                    }
                }
            }
        });
    });

});
